import { useState, type MouseEvent } from "react";
import { Check, Copy } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

export function CopyIdButton({ value, label }: { value: string; label: string }) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const [failed, setFailed] = useState(false);

  async function copy(event: MouseEvent<HTMLButtonElement>) {
    event.stopPropagation();
    event.preventDefault();
    try {
      if (!navigator.clipboard?.writeText) throw new Error("clipboard unavailable");
      await navigator.clipboard.writeText(value);
      setFailed(false);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1600);
    } catch {
      setCopied(false);
      setFailed(true);
      window.setTimeout(() => setFailed(false), 1600);
    }
  }

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon-sm"
      className="text-muted"
      onClick={(event) => void copy(event)}
      aria-label={failed ? t("common.copyFailed", "Copy failed") : copied ? t("common.copied", "Copied") : t("common.copyId", { label, defaultValue: `Copy ${label}` })}
    >
      {copied ? <Check className="size-3.5 text-success" aria-hidden="true" /> : <Copy className={failed ? "size-3.5 text-danger" : "size-3.5"} aria-hidden="true" />}
    </Button>
  );
}
